import React from 'react';
import Account from "../../../components/pages/grid/Account/Account";

const AccountGridPage = () => {
    return <Account />
};

export default AccountGridPage;